module.exports = __webpack_public_path__ + "static/media/sch_logo.1193afb1.svg";